export class User {
  username: string;
  password: string;
  token: string;
  mfaCode: string;
  timezone: string;

  constructor() {
    this.username = '';
    this.password = '';
    this.token = '';
    this.mfaCode = '';
    this.timezone = '';
  }
}
